//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SavedTime from "@/components/cards/SavedTime";
import DoubleLine from "@/components/charts/DoubleLine";

export default {
  name: "Outcome",
  components: {DoubleLine, SavedTime},

  props: {
    mission: {
      type: Object,
      default: () => {
      }
    },

    threshold: {
      type: Number,
      default: 0.5
    }
  },

  computed: {
    missionMetrics() {
      if (this.mission.contextParameters && this.mission.contextParameters.mission_metrics) {
        return this.mission.contextParameters.mission_metrics;
      }

      return {};
    },

    autofillPerformance() {
      if (this.missionMetrics.evaluation_autofill_performance) {
        return this.missionMetrics.evaluation_autofill_performance;
      }

      return [];
    },

    outputFocus() {
      let props = this.mission.properties;
      return props["ai_mission:output_focus"];
    },

    categoriesFocus() {
      let props = this.mission.properties;
      return props["ai_mission:categories_focus"];
    },

    baseline() {
      let result = {
        data: [],
        label: 'Without the mission impact',
        fill: false,
        backgroundColor: 'rgb(136,208,255)',
        borderColor: 'rgb(136,208,255)',
        tension: 0.1
      };

      if (this.autofillPerformance.length === 0) {
        return result;
      }

      let sorted = [...this.autofillPerformance].sort(this._comparatorT)
      let lastEvalCreated = sorted[sorted.length - 1].created;
      let data = sorted.reverse()
          .filter(val => val.created !== lastEvalCreated)
          .map(val => val.outputs)

      let mean = data.map(() => 0);
      let index = Math.ceil(this.threshold * 10) - 1;
      if (this.outputFocus && this.categoriesFocus) {
        let categories = data.map(val => val[this.outputFocus].categories);
        for (let category of this.categoriesFocus) {
          categories.map(val => Object.values(val[category][index])[0]).forEach((v, i) => mean[i] += v);
        }
        mean.forEach((v, i) => mean[i] = v / data.length);
      } else {
        mean = data.map(val => val[this.outputFocus].values)
            .map(val => val[index])
            .map(val => Object.values(val)[0]);
      }

      result.data = mean;
      return result;
    },

    performance() {
      let result = {
        data: [],
        label: 'With the mission impact',
        fill: false,
        backgroundColor: 'rgb(86,57,213)',
        borderColor: 'rgb(86,57,213)',
        tension: 0.1
      }

      if (this.autofillPerformance.length === 0) {
        return result;
      }

      let sorted = [...this.autofillPerformance].sort(this._comparatorT)

      let lastEvalCreated = sorted[sorted.length - 1].created;
      let data = sorted.filter(val => val.created === lastEvalCreated)
          .map(val => val.outputs);

      let mean = data.map(() => 0);
      let index = Math.ceil(this.threshold * 10) - 1;
      if (this.outputFocus && this.categoriesFocus) {
        let categories = data.map(val => val[this.outputFocus].categories);
        for (let category of this.categoriesFocus) {
          categories.map(val => Object.values(val[category][index])[0]).forEach((v, i) => mean[i] += v);
        }
        mean.forEach((v, i) => mean[i] = v / data.length);
      } else {
        mean = data.map(val => val[this.outputFocus].values)
            .map(val => val[index])
            .map(val => Object.values(val)[0]);
      }

      result.data = mean;
      return result;
    },

    labels() {
      if (this.autofillPerformance.length === 0) {
        return [];
      }

      let sorted = [...this.autofillPerformance].sort(this._comparatorT);
      return [...new Set(sorted.map(val => val.modelCreated))]
    },

    performanceTotalTime() {
      if (this.performance) {
        let total = this.performance.data.reduce((a, b) => a + b, 0);
        return Math.ceil(total * 30 / 60 / 60);
      }

      return 0;
    },

    baselineTotalTime() {
      if (this.baseline) {
        let total = this.baseline.data.reduce((a, b) => a + b, 0);
        return Math.ceil(total * 30 / 60 / 60);
      }

      return 0;
    }
  },

  methods: {
    _creator(val) {
      return {
        label: val.modelCreated,
        version: val.model_version,
        outputs: val.outputs
      }
    },

    _comparatorT(a, b) {
      return a.created - b.created;
    },

    _reducer(arr, obj) {
      arr.push(obj);
      return arr;
    }
  }
}
